export default __webpack_public_path__ + "locales/ja-JP/InviteDialog.json?hash=d53458767fd7329fa8b2f312cbb871eb";